import assignAirport from './assignAirport';
import EntityType from '../../schema/innerSchema/EntityType';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import setReservationEntityData from './setReservationEntityData';
import FlightReservation from '../../schema/FlightReservation';
import Entity from '../../schema/Entity';

/**
 * parse data for FlightReservation Entity
 */
export default function setFlightEntityData(
    entity: Entity,
    flightEntity: any,
    isValidDate?: (dateTime: string, isUtcTime: boolean, entity?: Entity) => boolean
): FlightReservation {
    if (entity && flightEntity) {
        let newFlightEntity: FlightReservation = setReservationEntityData(
            entity,
            flightEntity,
            false /* isReservationIdRequired */
        );
        // assign the flight data
        if (isFlightValid(flightEntity, entity, isValidDate)) {
            let reservationFor = flightEntity.reservationFor;
            let airline = reservationFor.provider;
            newFlightEntity = {
                ...newFlightEntity,
                ...{
                    entityName: EntityTypeNames.FlightReservation,
                    entityType: EntityType.FlightReservation,
                    checkinUrl: flightEntity.checkinUrl
                        ? flightEntity.checkinUrl
                        : flightEntity.potentialAction
                        ? flightEntity.potentialAction.target
                        : null,
                    departureTime: reservationFor.departureTime,
                    departureTimeUTC: reservationFor['departureTime/utc'],
                    departureTerminal: reservationFor.departureTerminal,
                    departureGate: reservationFor.departureGate,
                    departureTimeZone: reservationFor['departureTime/windowsTimeZoneName'],
                    arrivalTime: reservationFor.arrivalTime,
                    arrivalTimeUTC: reservationFor['arrivalTime/utc'],
                    arrivalTerminal: reservationFor.arrivalTerminal,
                    arrivalGate: reservationFor.arrivalGate,
                    arrivalTimeZone: reservationFor['arrivalTime/windowsTimeZoneName'],
                    flightNumber: reservationFor.flightNumber,
                    airline: {
                        name: airline.name,
                        iataCode: airline.iataCode,
                    },
                },
            };
            // assign data for departure airport
            newFlightEntity = <FlightReservation>{
                ...newFlightEntity,
                ...{
                    departureAirport: assignAirport(
                        newFlightEntity,
                        reservationFor.departureAirport
                    ),
                },
            };

            // assign data for arrival airport
            newFlightEntity = <FlightReservation>{
                ...newFlightEntity,
                ...{
                    arrivalAirport: assignAirport(newFlightEntity, reservationFor.arrivalAirport),
                },
            };

            return newFlightEntity as FlightReservation;
        }
    }
    return null;
}

export function isFlightValid(
    flightEntity: any,
    entity: Entity,
    isValidDate?: (dateTime: string, isUtcTime: boolean, entity?: Entity) => boolean
): boolean {
    if (flightEntity && flightEntity.reservationFor && flightEntity.reservationFor.provider) {
        let reservationFor = flightEntity.reservationFor;
        let provider = flightEntity.reservationFor.provider;

        const isDateValidUsingCallback: boolean = isValidDate
            ? isValidDate(reservationFor.arrivalTime, false /* isUtcTime*/, entity) &&
              isValidDate(reservationFor.arrivalTimeUTC, true /* isUtcTime*/, entity) &&
              isValidDate(reservationFor.departureTime, false /* isUtcTime*/, entity) &&
              isValidDate(reservationFor.departureTimeUTC, true /* isUtcTime*/, entity)
            : true;

        // validate Airline
        if (
            provider.iataCode &&
            provider.name &&
            // validate Airports
            isAirportValid(reservationFor.arrivalAirport) &&
            isAirportValid(reservationFor.departureAirport) &&
            // validate require flight details
            reservationFor.flightNumber &&
            reservationFor.arrivalTime &&
            reservationFor.departureTime &&
            isDateValidUsingCallback
        ) {
            return true;
        }
    }
    return false;
}

export function isAirportValid(airportBlob: any): boolean {
    if (
        airportBlob &&
        airportBlob.iataCode &&
        (airportBlob['address/commonCity'] ||
            (airportBlob.address && airportBlob.address.addressLocality))
    ) {
        return true;
    }
    return false;
}
